<div class="relative min-h-screen w-full bg-gray-900 flex flex-col items-center justify-center p-4">

  <!-- Background Image & Overlay -->
  <div class="fixed inset-0 z-0">
    <img src="assets/logos/women_with_phone.jpg" alt="Login Background" class="w-full h-full object-cover">
    <div class="absolute inset-0 bg-indigo-900/30"></div>
  </div>

  <!-- Login Card -->
  <div
    class="relative z-10 w-full max-w-[350px] bg-white backdrop-blur-md border border-white/50 rounded-2xl shadow-2xl p-4">

    <div *ngIf="isTestEnvironment"
      class="absolute top-3 left-3 px-2 py-0.5 bg-gray-100 border border-gray-600 rounded text-[11px] font-semibold tracking-wider text-gray-600 uppercase">
      Test Environment
    </div>

    <form (ngSubmit)="lFN_LoginUser()" #loginForm="ngForm" class="space-y-3">

      <!-- Header -->
      <div class="flex flex-col items-center mb-2">

        <img src="assets/logos/smart_ping_logo_transparent.png" alt="Logo" class="h-auto w-auto" />

        <div class="text-center">
          <!-- <h2 class="text-xl mt-2 font-semibold text-gray-800 tracking-tight uppercase">
              {{ envHeading || 'Sign In' }}
            </h2> -->
          <p class="text-xs text-gray-600 mt-1 font-medium">Please enter your details to continue</p>
        </div>
      </div>

      <!-- Username -->
      <mat-form-field appearance="outline" class="w-full">
        <mat-label>Username</mat-label>
        <input matInput placeholder="Enter username" name="username" required [(ngModel)]="l_formdata.username" />
        <mat-icon matSuffix class="text-gray-500">person</mat-icon>
      </mat-form-field>

      <!-- Password -->
      <mat-form-field appearance="outline" class="w-full">
        <mat-label>Password</mat-label>
        <input matInput [type]="l_hideView ? 'password' : 'text'" placeholder="Enter password" name="password" required
          [(ngModel)]="l_formdata.password" />

        <button mat-icon-button matSuffix type="button" (click)="lFN_TogglePasswordVisibility()"
          aria-label="Toggle password visibility">
          <mat-icon class="text-gray-500">
            {{ l_hideView ? 'visibility_off' : 'visibility' }}
          </mat-icon>
        </button>
      </mat-form-field>

      <!-- Login Button -->
      <button type="submit" [disabled]="!loginForm.valid" class="w-full h-10 rounded-md
                   bg-gradient-to-r from-slate-900 to-black
                   text-white text-[12px] font-medium tracking-widest uppercase
                   shadow hover:from-black hover:to-slate-800
                   disabled:opacity-50 disabled:cursor-not-allowed
                   transition-all duration-150 whitespace-nowrap">
        Login
      </button>

    </form>
  </div>

  <!-- Footer Label -->
  <div
    class="relative z-10 mt-2 px-3 py-1 bg-white backdrop-blur-md border border-white/50 rounded-xl shadow-md w-full max-w-sm flex items-center justify-center">

    <img src="assets/logos/concurrency_logo_white.jpeg" alt="Concurrency Logo" class="h-7 w-auto mix-blend-multiply">

    <span class="text-xs font-semibold tracking-wider text-gray-700 uppercase">
      Concurrency Global 2026 ©
    </span>

  </div>

</div>